import { ValueLabelPair } from '@components/table/types/DateMinMax.type';

type TFilterValues<v extends any> = {
  [x: string]: v;
};

export const getMetadataEntityValueHelper =
  (filterKey: string) =>
  (values: TFilterValues<string | ValueLabelPair>): ValueLabelPair | string | string[] => {
    const item = values[filterKey];

    if (typeof item === 'string') {
      return item;
    }
    if (Array.isArray(item)) {
      return item;
    }

    return item.value;
  };
